import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components/macro'

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.sizeByFactor(0.75)};
  min-width: 0;
  font-family: ${({ theme }) => theme.font};
  font-size: ${({ theme }) => theme.baseFontSize};
  font-weight: ${({ theme }) => theme.baseFontWeight};
  line-height: ${({ theme }) => theme.baseFontSize};
  color: ${({ theme }) => theme.colors.text};
`

const Item = styled.span`
  flex-shrink: 0;
  white-space: nowrap;

  ${({ $truncate }) =>
    $truncate &&
    `
      flex: 1 1 auto;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
`

const Divider = styled.span`
  flex-shrink: 0;
  width: 1px;
  height: ${({ theme }) => theme.sizeByFactor(1.5)};
  background-color: ${({ theme }) => theme.colors.brandDelta};
`

const isVisible = (item) => item !== null && item !== undefined && item !== ''

/**
 * Key specifications of a car (e.g. mileage, year and location) on a single
 * line, separated by dividers. Empty items are skipped and the last item is
 * truncated when the line is too long.
 */
const CarKeySpecs = ({ items, className, ...restProps }) => {
  const visibleItems = items.filter(isVisible)

  if (visibleItems.length === 0) {
    return null
  }

  return (
    <Container className={className} {...restProps}>
      {visibleItems.map((item, index) => (
        <React.Fragment key={index.toString()}>
          {index > 0 && <Divider />}
          <Item $truncate={index === visibleItems.length - 1}>{item}</Item>
        </React.Fragment>
      ))}
    </Container>
  )
}

CarKeySpecs.propTypes = {
  /** Already formatted values, e.g. ["127.458 km", 2014, "Locatie Eindhoven"] */
  items: PropTypes.arrayOf(PropTypes.node).isRequired,
  className: PropTypes.string,
}

CarKeySpecs.defaultProps = {
  className: null,
}

export default CarKeySpecs
